import { TFunction } from 'next-i18next'

export const STATUS_LIST = {
  ACCEPTED: 'ACCEPTED',
  ACOMPLECTED_IN_WAREHOUSE: 'ACOMPLECTED_IN_WAREHOUSE',
  APPROVED: 'APPROVED',
  CANCELED: 'CANCELED',
  CANCELLED: 'CANCELLED',
  CANCEL_REQUEST: 'CANCEL_REQUEST',
  CREATED: 'CREATED',
  DECLINED: 'DECLINED',
  DELIVERED: 'DELIVERED',
  DISPATCHED: 'DISPATCHED',
  EXPIRING: 'EXPIRING',
  FIRSTMILE: 'FIRST_MILE',
  FIRST_MILE: 'FIRST_MILE',
  HOLD: 'HOLD',
  PICKED_UP: 'PICKED_UP',
  PLACED_IN_CONSOLIDATION_CELL_IN_WAREHOUSE:
    'PLACED_IN_CONSOLIDATION_CELL_IN_WAREHOUSE',
  PLACED_IN_POSTAMAT: 'PLACED_IN_POSTAMAT',
  PRESORTED: 'PRESORTED',
  PROBLEM: 'PROBLEM',
  READY_FOR_WITHDRAW_FROM_PICKUP_POINT: 'READY_FOR_WITHDRAW_FROM_PICKUP_POINT',
  READY_TO_BE_SHIPPED_FROM_WAREHOUSE: 'READY_TO_BE_SHIPPED_FROM_WAREHOUSE',
  RECEIVED_IN_WAREHOUSE_IN_DETAILS: 'RECEIVED_IN_WAREHOUSE_IN_DETAILS',
  REJECTED: 'REJECTED',
  RETURNED_TO_PARTNER: 'RETURNED_TO_PARTNER',
  RETURNED: 'RETURNED',
  RETURNING: 'RETURNING',
  SORTED_IN_WAREHOUSE: 'SORTED_IN_WAREHOUSE',
  UTILIZED: 'UTILIZED',
  WAITING_FOR_REPICKUP: 'WAITING_FOR_REPICKUP',
  WITHDRAWN_FROM_PICKUP_POINT: 'WITHDRAWN_FROM_PICKUP_POINT',
  UNCLAIMED: 'UNCLAIMED',
  IN_PROGRESS: 'IN_PROGRESS',
  FULFILLMENT: 'FULFILLMENT',
}

export const ORDER_STATUSES = (t: TFunction): Array<any> => [
  {
    value: 'PLACED_IN_POSTAMAT',
    label: t('TEMPStatuses:PLACED_IN_POSTAMAT'),
  },
  {
    value: 'FIRST_MILE',
    label: t('TEMPStatuses:FIRST_MILE'),
  },
  {
    value: 'IN_PROGRESS',
    label: t('TEMPStatuses:IN_PROGRESS'),
  },
  {
    value: 'APPROVED',
    label: t('TEMPStatuses:APPROVED'),
  },
  {
    value: 'PICKED_UP',
    label: t('TEMPStatuses:PICKED_UP'),
  },
  {
    value: 'RETURNED',
    label: t('TEMPStatuses:RETURNED'),
  },
  {
    value: 'UNCLAIMED',
    label: t('TEMPStatuses:UNCLAIMED'),
  },
]

export const LINKS = {
  SHOP: [
    { page: 'dashboard' },
    { page: 'orders' },
    { page: 'documents' },
    { page: 'redirects' },
    { page: 'client-options' },
    { page: 'settings' }
  ],
  PPN: [{ page: 'orders' }],
}

export const INSALES_TAXTYPE_OPTIONS = (t: TFunction) => [
  {
    label: t('USN'),
    value: 'usn',
  },
  {
    label: t('OSNO'),
    value: 'osno',
  },
]

export const DEALER_TYPES = {
  SHOP: 'SHOP',
  PPN: 'PPN',
}

export const COUNTRY_LANG = {
  en: 'US',
  ru: 'RU',
}

export const QUERY_TYPES = {
  ORDERS: 'orders',
  ORDER_INFO: 'order',
  PICK_UP: 'pick_up',
}

export const DEFAULT_SHOWED_COLUMNS = [
  'ext_key',
  'datetime',
  'sum',
  'commission',
  'total',
  'paid',
  'status'
]

export const ALL_ORDERS_COLUMNS = () => [
	{
		Header: 'Date / Time',
		accessor: 'datetime',
	},
	{
		Header: 'Sent to VD',
		accessor: 'created_at',
	},
	{
		Header: 'Timezone',
		accessor: 'timezone',
	},
	{
		Header: 'Order num',
		accessor: 'ext_key',
	},
	{
		Header: 'Payment Method',
		accessor: 'service_name',
	},
	{
		Header: 'Paid',
		accessor: 'paid',
	},
	{
		Header: 'Status',
		accessor: 'status',
		textAlign: 'center',
	},
	{
		Header: 'Status Date',
		accessor: 'statusDate',
	},
	{
		Header: 'Why Via?',
		accessor: 'Why Via?',
	},
	{
		Header: 'NPS',
		accessor: 'nps',
	},
	{
		Header: 'orderWeight',
		accessor: 'orderWeightKg',
		textAlign: 'right',
	},
	{
		Header: 'Package Name',
		accessor: 'packageName',
	},
	{
		Header: 'Order price',
		accessor: 'sum',
		textAlign: 'right',
	},
	{
		Header: 'Taxes Included',
		accessor: 'taxes_included',
		textAlign: 'right',
	},
	{
		Header: 'Discount',
		accessor: 'discount_included',
		textAlign: 'right',
	},
	{
		Header: 'Package price',
		accessor: 'packagePrice',
		textAlign: 'right',
	},
	{
		Header: 'Delivery price',
		accessor: 'commission',
		textAlign: 'right',
	},
	{
		Header: 'Total price',
		accessor: 'total',
		textAlign: 'right',
	},
	{
		Header: 'Delivery cost',
		accessor: 'delivery_cost_dealer',
		textAlign: 'right',
	},
	{
		Header: 'Currency',
		accessor: 'currency',
	},
	{
		Header: 'Tracking',
		accessor: 'tracking_url',
	},
	{
		Header: 'Origin City',
		accessor: 'originCity'
	},
	{
		Header: 'Origin Region',
		accessor: 'originRegion'
	},
	{
		Header: 'Origin Country',
		accessor: 'dealer_country'
	},
	{
		Header: 'Customer Name',
		accessor: 'customer_name'
	},
	{
		Header: 'Delivery Location',
		accessor: 'Delivery Location'
	},
	{
		Header: 'Delivery Street',
		accessor: 'Delivery Street'
	},
	{
		Header: 'Delivery City',
		accessor: 'city'
	},
	{
		Header: 'Delivery Region',
		accessor: 'region'
	},
	{
		Header: 'Delivery Country',
		accessor: 'country'
	},
	{
		Header: 'Delivery Zone',
		accessor: 'zone'
	},
	{
		Header: 'Partner',
		accessor: 'partner',
	},
	{
		Header: 'Account Number',
		accessor: 'partnerAccountNumber',
	},
	{
		Header: 'Delivery Started Date',
		accessor: 'deliveryStartedDate'
	},
	{
		Header: 'Delivery Date',
		accessor: 'delivery_date'
	},
	{
		Header: 'Expiration Date',
		accessor: 'expiration_date'
	},
	{
		Header: 'Delivery Completed',
		accessor: 'delivery_complete',
	},
	{
		Header: 'Shipment Manifest',
		accessor: 'manifest'
	},
	{
		Header: 'Delivery Barcode',
		accessor: 'delivery_barcode'
	},
	{
		Header: 'Dealer Name',
		accessor: 'dealer_name',
	},
	{
		Header: 'Author Name',
		accessor: 'authorName',
	},
	{
		Header: 'Origin Name',
		accessor: 'originName',
	},
]

export const ALL_ORDERS_COLUMNS_EN = () => [
	{
		Header: 'Date / Time',
		accessor: 'datetime',
	},
	{
		Header: 'Sent to VD',
		accessor: 'created_at',
	},
	{
		Header: 'Timezone',
		accessor: 'timezone',
	},
	{
		Header: 'Order num',
		accessor: 'ext_key',
	},
	{
		Header: 'Payment Method',
		accessor: 'service_name',
	},
	{
		Header: 'Paid',
		accessor: 'paid',
	},
	{
		Header: 'Status',
		accessor: 'status',
		textAlign: 'center',
	},
	{
		Header: 'Status Date',
		accessor: 'statusDate',
	},
	{
		Header: 'Why Via?',
		accessor: 'Why Via?',
	},
	{
		Header: 'NPS',
		accessor: 'nps',
	},
	{
		Header: 'orderWeight',
		accessor: 'orderWeightKg',
		textAlign: 'right',
	},
	{
		Header: 'Package Count',
		accessor: 'multiplePackagesCount',
	},
	{
		Header: 'Package Name',
		accessor: 'packageName',
	},
	{
		Header: 'Order price',
		accessor: 'sum',
		textAlign: 'right',
	},
	{
		Header: 'Taxes Included',
		accessor: 'taxes_included',
		textAlign: 'right',
	},
	{
		Header: 'Discount',
		accessor: 'discount_included',
		textAlign: 'right',
	},
	{
		Header: 'Package price',
		accessor: 'packagePrice',
		textAlign: 'right',
	},
	{
		Header: 'Delivery price',
		accessor: 'commission',
		textAlign: 'right',
	},
	{
		Header: 'Total price',
		accessor: 'total',
		textAlign: 'right',
	},
	{
		Header: 'Delivery cost',
		accessor: 'delivery_cost_dealer',
		textAlign: 'right',
	},
	{
		Header: 'Currency',
		accessor: 'currency',
	},
	{
		Header: 'Origin City',
		accessor: 'originCity'
	},
	{
		Header: 'Origin Region',
		accessor: 'originRegion'
	},
	{
		Header: 'Origin Country',
		accessor: 'dealer_country'
	},
	{
		Header: 'Customer Name',
		accessor: 'customer_name'
	},
	{
		Header: 'Delivery Location',
		accessor: 'Delivery Location'
	},
	{
		Header: 'Delivery Street',
		accessor: 'Delivery Street'
	},
	{
		Header: 'Delivery City',
		accessor: 'city'
	},
	{
		Header: 'Delivery Region',
		accessor: 'region'
	},
	{
		Header: 'Delivery Country',
		accessor: 'country'
	},
	{
		Header: 'Delivery Zone',
		accessor: 'zone'
	},
	{
		Header: 'Partner',
		accessor: 'partner',
	},
	{
		Header: 'Account Number',
		accessor: 'partnerAccountNumber',
	},
	{
		Header: 'Address Change Date',
		accessor: 'Address Change Date',
	},
	{
		Header: 'Delivery Started Date',
		accessor: 'deliveryStartedDate'
	},
	{
		Header: 'Delivery Date',
		accessor: 'delivery_date'
	},
	{
		Header: 'Delivery Completed',
		accessor: 'delivery_complete',
	},
	{
		Header: 'Expiration Date',
		accessor: 'expiration_date'
	},
	{
		Header: 'Shipment Manifest',
		accessor: 'manifest'
	},
	{
		Header: 'Delivery Barcode',
		accessor: 'delivery_barcode'
	},
	{
		Header: 'Tracking',
		accessor: 'tracking_url',
	},
	{
		Header: 'Dealer Name',
		accessor: 'dealer_name',
	},
	{
		Header: 'Author Name',
		accessor: 'authorName',
	},
	{
		Header: 'Origin Name',
		accessor: 'originName',
	},
]

export class OrdersCommon {
	
	static getSortedOrdersColumns(row) {
		const enCountries = ['US', 'GB', 'UK', 'CA']
		if (enCountries.includes(row?.dealer_country)) {
			let orderColumns = []
			let columnsCount = OrdersCommon.usColumnsOrder.length
			Object.keys(row).sort((a, b) => {
				let aOrder = OrdersCommon.usColumnsOrder.indexOf(a)
				if (aOrder < 0)	aOrder = columnsCount
				let bOrder = OrdersCommon.usColumnsOrder.indexOf(b)
				if (bOrder < 0)	bOrder = columnsCount
				return aOrder - bOrder
			}).forEach(column => {
				if (!column.startsWith('_')) {
					orderColumns.push(column)
				}
			})
			return orderColumns
		} else {
			return OrdersCommon.defaultColumnsOrder
		}
	}
	
	static get usColumnsOrder() {
		return [
			'Order Date',
			'Sent to VD',
			'Time Zone',
			'Order Number',,
			'Payment Method',
			'Status',
			"Status Date",
			'Why Via?',
			'NPS',
			'Customer Comment',
			'KgWeight',
			'Package Count',
			'Package Name',
			'Paid',
			'Order Price',
			'Taxes Included',
			'Discount',
			'Package Price',
			'Delivery Price',
			'Total Price',
			'Delivery Cost',
			'Currency',
			'Origin City',
			'Origin Region',
			'Origin Country',
			'Customer Name',
			'Delivery Location',
			'Delivery Street',
			'Delivery City',
			'Delivery Region',
			'Delivery Country',
			'Delivery Zone',
			'Partner',
			'Partner Account',
			'Address Change Date',
			'Delivery Started Date',
			'Delivery Date',
			'Delivery Completed',
			'Expiration Date',
			'Shipment Manifest',
			'Delivery Barcode',
			'Delivery Tracking',
			'Dealer Name',
			'Author Name',
			'Origin Name',
		]
	}
	
	static get defaultColumnsOrder() {
		return [
			'Order Date',
			'Sent to VD',
			'Time Zone',
			'Order Number',
			'Payment Method',
			'Status',
			"Status Date",
			'Why Via?',
			'NPS',
			'Customer Comment',
			'KgWeight',
			'Package Name',
			'Paid',
			'Order Price',
			'Taxes Included',
			'Discount',
			'Package Price',
			'Delivery Price',
			'Total Price',
			'Delivery Cost',
			'Currency',
			'Delivery Tracking',
			'Origin City',
			'Origin Region',
			'Origin Country',
			'Customer Name',
			'Delivery Location',
			'Delivery Street',
			'Delivery City',
			'Delivery Region',
			'Delivery Country',
			'Delivery Zone',
			'Partner',
			'Partner Account',
			'Delivery Started Date',
			'Delivery Date',
			'Expiration Date',
			'Delivery Completed',
			'Shipment Manifest',
			'Delivery Barcode',
			'Dealer Name',
			'Author Name',
			'Origin Name',
		]
	}
}
